var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{attrs:{"has-icon":true,"icon":"check","closable":false}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('compCarbonFormsFoodsHelpEmissionsFactors.text'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }